import { ApolloLink, Observable, Operation, FetchResult, NextLink } from '@apollo/client/core';
import { UtilitiesService } from '../../services/utilities.service';
import { inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

export class GraphQLLoggerLink extends ApolloLink {
  readonly #utilitiesService = inject(UtilitiesService);
  readonly #loaderService = inject(LoaderService);
  readonly #appLoader = 'graphqlLoader';

  constructor() {
    super();
  }

  public override request(operation: Operation, forward: NextLink): Observable<FetchResult> | null {
    this.#loaderService.showLoader(this.#appLoader);

    return new Observable<FetchResult>((observer) => {
      const subscription = forward(operation).subscribe({
        next: (result) => {
          if (result.errors && result.errors.length > 0) {
            const errorMessage = result.errors.map(error => error.message).join(', ');
            this.#utilitiesService.showSnackbar('Error! ' + errorMessage);
            console.error(errorMessage);
          }
          this.#loaderService.dismissLoader(this.#appLoader);
          observer.next(result);
        },
        error: (networkError) => {
          const errorMessage = networkError?.message || 'Unknown network error';
          this.#utilitiesService.showSnackbar('Error! ' + errorMessage);
          console.error(errorMessage);

          this.#loaderService.dismissLoader(this.#appLoader);
          observer.error(networkError);
        },

        complete: () => {
          observer.complete();
        }
      });

      return () => subscription.unsubscribe();
    });
  }

  private getOperationType(operation: Operation): string {
    const definition = operation.query.definitions[0];
    if (definition.kind === 'OperationDefinition') {
      return definition.operation.toUpperCase();
    }
    return 'UNKNOWN';
  }
}

